(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dnd-contact-enquiries"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dnd-contact-flow')) {
  customElements.define('dnd-contact-flow', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.checkedFields = new WeakSet();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), {
          once: true,
          signal: this.controller.signal
        });
      }
      queueMicrotask(() => this.initialize());
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.initialized = false;
    }

    initialize() {
      if (!this.isConnected || !this.controller || this.initialized) return;
      this.form = this.querySelector('form[data-contact-form]');
      const labels = this.querySelector('script[data-contact-labels]');
      if (!this.form || !labels) return;
      try {
        this.labels = JSON.parse(labels.textContent);
      } catch {
        return;
      }
      const success = this.querySelector('[data-server-success]');
      if (success) {
        this.initialized = true;
        if (!success.hasAttribute('tabindex')) success.tabIndex = -1;
        requestAnimationFrame(() => {
          if (success.isConnected) success.focus();
        });
        return;
      }
      this.radios = Array.from(this.form.querySelectorAll('input[type="radio"][name="contact[enquiry_type]"][data-topic]'));
      if (!this.radios.length) return;
      this.initialized = true;
      this.message = this.form.querySelector('textarea[data-message]');
      this.hint = this.querySelector('p[data-message-hint]');
      this.counter = this.querySelector('[data-character-count]');
      this.status = this.querySelector('[data-topic-status]');
      this.sendLabel = this.form.querySelector('[data-send-label]');
      this.submitLabel = this.labels.submit_label || this.sendLabel?.textContent || '';
      const signal = this.controller.signal;

      this.form.addEventListener('change', event => {
        const field = event.target;
        if (this.radios.includes(field)) this.selectTopic(field.dataset.topic, true);
        if (field.matches('[data-product-group], [data-fox-help]')) this.updateNestedFields();
        this.refreshField(field);
      }, { signal });

      this.form.addEventListener('input', event => {
        this.refreshField(event.target);
        if (event.target === this.message) this.updateCount();
      }, { signal });

      this.form.addEventListener('invalid', event => {
        this.applyTrimValidity(event.target, true);
        this.checkedFields.add(event.target);
        this.renderFieldError(event.target);
      }, { capture: true, signal });

      this.form.addEventListener('submit', event => {
        setTimeout(() => {
          if (event.defaultPrevented || !this.isConnected) return;
          if (Array.from(this.form.elements).some(field => field.willValidate && !field.validity.valid)) return;
          this.form.setAttribute('aria-busy', 'true');
          if (this.sendLabel && this.labels.sending_label) this.sendLabel.textContent = this.labels.sending_label;
        }, 0);
      }, { signal });

      document.addEventListener('click', event => {
        const anchor = event.target.closest?.('a[data-enquiry-start]');
        if (!anchor) return;
        const url = new URL(anchor.href, window.location.href);
        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || url.hash !== '#enquiry-form') return;
        requestAnimationFrame(() => {
          if (!event.defaultPrevented && this.isConnected) this.focusTopics();
        });
      }, { signal });

      window.addEventListener('hashchange', () => {
        if (window.location.hash === '#packout-enquiry') this.selectTopic('packout', true);
      }, { signal });

      window.addEventListener('pageshow', () => {
        this.resetSending();
        const checked = this.radios.find(radio => radio.checked);
        if (checked) this.selectTopic(checked.dataset.topic, false);
        this.updateCount();
      }, { signal });

      const queryTopic = new URL(window.location.href).searchParams.get('enquiry');
      const requestedTopic = window.location.hash === '#packout-enquiry' ? 'packout' : queryTopic;
      const initial = this.radios.find(radio => radio.dataset.topic === requestedTopic)
        || this.radios.find(radio => radio.checked)
        || this.radios[0];
      this.selectTopic(initial.dataset.topic, false);
      this.form.querySelectorAll('[data-required-label]').forEach(field => this.applyTrimValidity(field));
      this.updateCount();
      this.resetSending();

      const result = this.querySelector('[data-server-error]') || this.querySelector('[data-server-success]');
      if (result) {
        if (!result.hasAttribute('tabindex')) result.tabIndex = -1;
        requestAnimationFrame(() => {
          if (result.isConnected) result.focus();
        });
      }
    }

    format(template, values) {
      return String(template || '').replace(/\{\{\s*(\w+)\s*\}\}|\{(\w+)\}/g, (match, doubleKey, singleKey) => {
        const key = doubleKey || singleKey;
        return Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match;
      });
    }

    selectTopic(topic, announce) {
      const radio = this.radios.find(item => item.dataset.topic === topic);
      if (!radio) return;
      this.radios.forEach(item => { item.checked = item === radio; });
      this.form.querySelectorAll('fieldset[data-topic-panel]').forEach(panel => {
        const active = panel.dataset.topicPanel === topic;
        panel.hidden = !active;
        panel.disabled = !active;
      });
      const subject = this.form.querySelector('input[data-subject]');
      if (subject) subject.value = [this.labels.subject_prefix, radio.value].filter(Boolean).join(' — ');
      if (this.message) this.message.placeholder = radio.dataset.placeholder || '';
      if (this.hint) this.hint.textContent = radio.dataset.messageHint || '';
      this.updateNestedFields();
      if (announce && this.status) this.status.textContent = this.format(this.labels.topic_changed, { topic: radio.value });
    }

    updateNestedFields() {
      const topic = this.radios.find(radio => radio.checked)?.dataset.topic;
      const vehicleFields = this.form.querySelector('fieldset[data-vehicle-fields]');
      if (vehicleFields) {
        const active = topic === 'product' && this.form.querySelector('[data-product-group]')?.value === 'sxs';
        vehicleFields.hidden = !active;
        vehicleFields.disabled = !active;
      }
      const technicalFields = this.form.querySelector('fieldset[data-technical-fields]');
      if (technicalFields) {
        const active = topic === 'foxgps' && this.form.querySelector('[data-fox-help]')?.value === 'technical';
        technicalFields.hidden = !active;
        technicalFields.disabled = !active;
      }
    }

    requiredMessage(field) {
      const keys = { 'contact[name]': 'name_required', 'contact[email]': 'email_required', 'contact[body]': 'message_required' };
      return field.dataset.requiredLabel || this.labels[keys[field.name]] || '';
    }

    applyTrimValidity(field, includeEmpty = false) {
      if (!field.matches?.('[data-required-label]') || typeof field.setCustomValidity !== 'function') return;
      const value = field.value || '';
      const blank = field.required && !value.trim() && (value.length > 0 || includeEmpty);
      field.setCustomValidity(blank ? this.requiredMessage(field) : '');
    }

    refreshField(field) {
      if (!field || typeof field.checkValidity !== 'function') return;
      this.applyTrimValidity(field);
      if (this.checkedFields.has(field) || field.getAttribute('aria-invalid') === 'true') this.renderFieldError(field);
    }

    renderFieldError(field) {
      if (!field.id || !field.validity) return;
      const error = Array.from(this.querySelectorAll('[data-field-error]')).find(element => element.id === field.id + '-error');
      const invalid = field.willValidate && !field.validity.valid;
      if (invalid) field.setAttribute('aria-invalid', 'true');
      else field.removeAttribute('aria-invalid');
      if (error) {
        error.textContent = invalid ? field.validationMessage : '';
        error.hidden = !invalid;
      }
    }

    updateCount() {
      if (!this.message || !this.counter || !this.labels.character_count) return;
      this.counter.textContent = this.format(this.labels.character_count, {
        count: this.message.value.length,
        max: this.message.maxLength
      });
    }

    resetSending() {
      this.form?.removeAttribute('aria-busy');
      if (this.sendLabel) this.sendLabel.textContent = this.submitLabel;
    }

    focusTopics() {
      const options = this.querySelector('fieldset[data-topic-options]');
      if (!options) return;
      options.focus({ preventScroll: true });
      options.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dnd-reels-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dnd-reels-hero')) {
    customElements.define('dnd-reels-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.video = this.querySelector('video');
        this.choices = [...this.querySelectorAll('[data-reel-choice]')];
        if (!this.video || !this.choices.length) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.index = 0;
        this.visible = false;
        this.failed = new Set();
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.motion.matches || Boolean(navigator.connection?.saveData);
        this.video.muted = true;
        this.choices.forEach((choice, index) => choice.addEventListener('click', () => this.select(index), options));
        this.querySelector('[data-reel-prev]').addEventListener('click', () => this.select(this.index - 1), options);
        this.querySelector('[data-reel-next]').addEventListener('click', () => this.select(this.index + 1), options);
        this.querySelector('[data-reel-pause]').addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.syncPlayback();
        }, options);
        this.video.addEventListener('ended', () => {
          if (!this.userPaused) this.select(this.index + 1);
        }, options);
        this.video.addEventListener('timeupdate', () => {
          const percent = this.video.duration ? Math.min(100, this.video.currentTime / this.video.duration * 100) : 0;
          this.style.setProperty('--reel-progress', `${percent}%`);
        }, options);
        this.video.addEventListener('error', () => {
          this.failed.add(this.index);
          if (this.failed.size >= this.choices.length) {
            this.userPaused = true;
            this.syncPlayback();
          } else this.select(this.index + 1);
        }, options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        this.motion.addEventListener('change', event => {
          if (event.matches) this.userPaused = true;
          this.syncPlayback();
        }, options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.syncPlayback();
        }, { threshold: 0.15 });
        this.observer.observe(this.querySelector('.dnd-reels__screen'));
        this.syncPlayback();
      }
      select(index) {
        this.index = (index + this.choices.length) % this.choices.length;
        const item = this.choices[this.index];
        this.video.pause();
        this.video.src = item.dataset.src;
        this.video.poster = item.dataset.poster;
        this.video.setAttribute('aria-label', item.dataset.title);
        this.querySelector('[data-reel-title]').textContent = item.dataset.title;
        this.querySelector('[data-reel-link]').href = item.dataset.link;
        this.querySelector('[data-reel-count]').textContent = `${String(this.index + 1).padStart(2, '0')} / ${String(this.choices.length).padStart(2, '0')}`;
        this.choices.forEach((choice, i) => choice.setAttribute('aria-current', String(i === this.index)));
        this.style.setProperty('--reel-progress', '0%');
        this.video.load();
        this.syncPlayback();
      }
      syncPlayback() {
        const button = this.querySelector('[data-reel-pause]');
        button.setAttribute('aria-pressed', String(this.userPaused));
        this.querySelector('[data-pause-text]').textContent = this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel;
        if (this.userPaused || !this.visible || document.hidden) {
          this.video.pause();
          return;
        }
        this.video.play().catch(error => {
          if (error.name === 'AbortError') return;
          this.userPaused = true;
          button.setAttribute('aria-pressed', 'true');
          this.querySelector('[data-pause-text]').textContent = this.dataset.playLabel;
        });
      }
      disconnectedCallback() {
        this.video?.pause();
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dnd-reviews-hub"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('dnd-review-library')) return;

  const normalizeSearch = (value) => String(value || '')
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ');

  class DndReviewLibrary extends HTMLElement {
    connectedCallback() {
      if (this._reviewAbortController) return;

      const controls = this.querySelector('[data-review-filters]');
      const buttons = Array.from(this.querySelectorAll('[data-review-filter]'));
      const search = this.querySelector('[data-review-search]');
      const count = this.querySelector('[data-review-count]');
      const empty = this.querySelector('[data-review-empty]');
      const clear = this.querySelector('[data-review-clear]');
      const cards = Array.from(this.querySelectorAll('[data-review-card]'), (element) => ({
        element,
        topic: element.dataset.topic,
        searchText: normalizeSearch(element.dataset.search),
      }));

      if (!controls || !buttons.length || !search || !cards.length) return;

      const topics = new Set(['all', 'reviews', 'guides', 'updates']);
      const initialButton = buttons.find((button) => (
        button.getAttribute('aria-pressed') === 'true' && topics.has(button.dataset.topic)
      ));
      let selectedTopic = initialButton ? initialButton.dataset.topic : 'all';
      const controller = new AbortController();
      this._reviewAbortController = controller;

      const update = () => {
        const query = normalizeSearch(search.value);
        let visibleCount = 0;

        cards.forEach(({ element, topic, searchText }) => {
          const matches = (selectedTopic === 'all' || topic === selectedTopic)
            && (!query || searchText.includes(query));
          element.hidden = !matches;
          if (matches) visibleCount += 1;
        });

        buttons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.topic === selectedTopic));
        });

        if (count) {
          const template = visibleCount === 1
            ? (count.dataset.countOne || '__count__')
            : (count.dataset.countOther || '__count__');
          const message = template.replace(/__count__/g, String(visibleCount));
          if (count.textContent !== message) count.textContent = message;
        }

        if (empty) empty.hidden = visibleCount !== 0;
      };

      buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          if (!topics.has(button.dataset.topic)) return;
          selectedTopic = button.dataset.topic;
          update();
        }, { signal: controller.signal });
      });

      search.addEventListener('input', update, { signal: controller.signal });
      search.addEventListener('search', update, { signal: controller.signal });

      if (clear) {
        clear.addEventListener('click', (event) => {
          event.preventDefault();
          selectedTopic = 'all';
          search.value = '';
          update();
          search.focus({ preventScroll: true });
        }, { signal: controller.signal });
      }

      update();
      controls.hidden = false;
    }

    disconnectedCallback() {
      this._reviewAbortController?.abort();
      this._reviewAbortController = null;
    }
  }

  customElements.define('dnd-review-library', DndReviewLibrary);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
